import { render, staticRenderFns } from "./FooterSocialIconV2.vue?vue&type=template&id=84ab6804&scoped=true&"
import script from "./FooterSocialIconV2.vue?vue&type=script&lang=ts&"
export * from "./FooterSocialIconV2.vue?vue&type=script&lang=ts&"
import style0 from "./FooterSocialIconV2.vue?vue&type=style&index=0&id=84ab6804&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84ab6804",
  null
  
)

export default component.exports